import type { FaqItem } from '../types/content'

export const faqs: FaqItem[] = [
  {
    question: { en: 'How much does painting cost?', es: '¿Cuánto cuesta pintar?' },
    answer: {
      en: 'It depends on square footage, ceiling height, surface condition and the number of colors. That is why we do not publish prices — we measure in person and give you a written line-item quote for free, so you know exactly what you are paying for.',
      es: 'Depende de los metros, la altura del techo, la condición de la superficie y la cantidad de colores. Por eso no publicamos precios — medimos en persona y te damos un presupuesto escrito y detallado, gratis, para que sepas exactamente qué pagas.',
    },
  },
  {
    question: { en: 'Do you offer free estimates?', es: '¿Ofrecen presupuestos gratis?' },
    answer: {
      en: 'Always. On-site consultation, measurements and a written quote cost you nothing and carry no obligation. Most estimates are scheduled within 24–48 hours of your call.',
      es: 'Siempre. La consulta en sitio, las medidas y el presupuesto escrito no te cuestan nada ni te comprometen. La mayoría de presupuestos se agendan en 24–48 horas.',
    },
  },
  {
    question: { en: 'How long does a project take?', es: '¿Cuánto tiempo toma un proyecto?' },
    answer: {
      en: 'A single room repaint is usually one day. A whole-home interior runs 4–7 days, flooring 2–4 days per 1,000 sq ft, and a kitchen or bathroom remodel 1–3 weeks. Your quote includes a specific day count and start date.',
      es: 'Pintar una habitación normalmente toma un día. El interior de una casa completa 4–7 días, pisos 2–4 días por cada 1,000 pies cuadrados, y remodelar cocina o baño de 1 a 3 semanas. Tu presupuesto incluye los días exactos y la fecha de inicio.',
    },
  },
  {
    question: { en: 'Are you licensed and insured?', es: '¿Están licenciados y asegurados?' },
    answer: {
      en: 'Yes. M&S Multiservices is licensed and carries liability insurance for every job we take, residential and commercial. We are glad to send documentation before work begins.',
      es: 'Sí. M&S Multiservices está licenciado y cuenta con seguro de responsabilidad para cada trabajo, residencial y comercial. Con gusto enviamos la documentación antes de comenzar.',
    },
  },
  {
    question: { en: 'Do you provide a warranty on your work?', es: '¿Dan garantía en su trabajo?' },
    answer: {
      en: 'Yes — workmanship is guaranteed in writing on every quote. If something related to our labor fails, we come back and correct it at no cost to you.',
      es: 'Sí — la mano de obra está garantizada por escrito en cada presupuesto. Si algo relacionado con nuestro trabajo falla, regresamos y lo corregimos sin costo.',
    },
  },
  {
    question: { en: 'Can you work on weekends?', es: '¿Pueden trabajar los fines de semana?' },
    answer: {
      en: 'Saturdays are a normal work day for us, 8:00 AM to 4:00 PM. Sunday work can be arranged for occupied businesses or urgent jobs — just ask when you call.',
      es: 'Los sábados son día normal de trabajo, de 8:00 AM a 4:00 PM. El domingo se puede coordinar para negocios en operación o trabajos urgentes — solo pregúntanos al llamar.',
    },
  },
  {
    question: { en: 'Do you offer same-day service?', es: '¿Ofrecen servicio el mismo día?' },
    answer: {
      en: 'For small repairs, drywall patches, handyman work and junk removal we can often be there the same day depending on crew availability. Call or WhatsApp us and we will tell you honestly.',
      es: 'Para reparaciones pequeñas, parches de drywall, handyman y retiro de basura muchas veces llegamos el mismo día, según la disponibilidad del equipo. Llámanos o escríbenos por WhatsApp y te decimos con honestidad.',
    },
  },
  {
    question: { en: 'What areas do you service?', es: '¿Qué áreas atienden?' },
    answer: {
      en: 'All of Dallas-Fort Worth and surrounding areas — Dallas, Fort Worth, Arlington, Plano, Irving, Garland, Frisco, McKinney, Richardson, Carrollton, Denton and more. If you are near the Metroplex, call and ask.',
      es: 'Todo Dallas-Fort Worth y áreas cercanas — Dallas, Fort Worth, Arlington, Plano, Irving, Garland, Frisco, McKinney, Richardson, Carrollton, Denton y más. Si estás cerca del Metroplex, llama y pregunta.',
    },
  },
  {
    question: { en: 'How do I get started?', es: '¿Cómo empiezo?' },
    answer: {
      en: 'Call or WhatsApp +1 (214) 259-5582, or send the estimate form with your address and what you need. We confirm a visit time, come measure, and you get your quote — usually within a day.',
      es: 'Llama o escribe por WhatsApp al +1 (214) 259-5582, o envía el formulario con tu dirección y lo que necesitas. Confirmamos la visita, medimos, y recibes tu presupuesto — normalmente en un día.',
    },
  },
]
